import { FormEventHandler, memo, ReactNode, useMemo } from 'react'
import { Button, IconButton, Modal, ModalFooter, ModalHeader } from '@cargomart/ui'
import { FloatingOverlay } from '@floating-ui/react'
import { useNavigate } from '@tanstack/react-router'
import IconArrowLeft from 'remixicon/icons/Arrows/arrow-left-line.svg?react'
import { useTypedSelector } from 'src/hooks'
import { authRoute } from 'src/modules/login/routes'

import OrderGuestSubmit from './OrderGuestKDVIDCreateForm/OrderGuestSubmit'

interface IProps {
  children: ReactNode
  onClose: () => void
  onSubmit: FormEventHandler<HTMLFormElement>
  className?: string
  isLoading?: boolean
  isShowPhone?: boolean
}

export const OrderGuestCreateFormMobile = memo<IProps>(function OrderGuestCreateFormMobile({
  className,
  children,
  isLoading,
  onClose,
  onSubmit,
  isShowPhone
}) {
  const navigate = useNavigate()
  const { fromPoint, toPoint } = useTypedSelector((state) => state.orderAddReducer)

  // TODO это костыль тк selectAddress не имеет валидации значения и проброса ошибки в форму
  const submitDisable = useMemo(() => Boolean(toPoint.errorAddress || fromPoint.errorAddress), [toPoint, fromPoint])

  return (
    <FloatingOverlay lockScroll className="z-modal">
      <form className={className} name="createOrderGuestForm" onSubmit={onSubmit}>
        <Modal isCloseOnEsc isMobile id="createOrderGuestFormMobile">
          <ModalHeader isBgSurface isSticky className="flex items-center justify-between p-2">
            <div className="flex w-full items-center">
              <IconButton className="mr-2" onClick={onClose}>
                <IconArrowLeft containerSize="lg" size="sm" />
              </IconButton>
              <div className="text-headline-md">Оформление заявки</div>
              <Button className="ml-auto !w-max" onClick={() => navigate(authRoute)}>
                Войти
              </Button>
            </div>
          </ModalHeader>

          <div className="flex-grow px-4 py-2 pt-2">{children}</div>

          <ModalFooter isBgSurface isSticky className="p-2">
            {isShowPhone ? (
              <OrderGuestSubmit />
            ) : (
              <Button
                className="block w-full"
                data-test-id="createOrderGuestFormMobileSubmit"
                disabled={submitDisable}
                loading={isLoading}
                size="lg"
                type="submit"
                variant="solid"
              >
                Заказать
              </Button>
            )}
          </ModalFooter>
        </Modal>
      </form>
    </FloatingOverlay>
  )
})
